module.exports = __webpack_public_path__ + "img/BAU_Partners_Infographics_24.58879772.png";